import React from "react";
import ForwardArrow from "../../../assets/svg/ForwardArrow";

type LinkWithArrowsProps = {
  text: string;
};

const LinkWithArrows: React.FC<LinkWithArrowsProps> = ({ text }) => {
  return (
    <p className="group mt-[32px] flex cursor-pointer items-center justify-center gap-[10px] text-center">
      <span>{text}</span>
      <span className="-mt-[2px] block group-hover:hidden">
        <ForwardArrow type="dark" />
      </span>
      <span className="-mt-[2px] hidden group-hover:block">
        <ForwardArrow type="light" />
      </span>
    </p>
  );
};

export default LinkWithArrows;
